import fetch from "node-fetch"

const localize = (entity, locale, translationField = "data") => {
  if (!entity || !entity[translationField]) return {}
  const entityFallback =
    entity[translationField].find(tf => tf.lang === "en") ||
    entity[translationField][0]
  const translatedData =
    entity[translationField].find(translation => translation.lang === locale) ||
    entityFallback
  const newData = { ...entity, ...translatedData }
  delete newData.data
  return newData
}

const slugify = text => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "") // Trim - from end of text
}

const createMarkup = __html => {
  return {
    __html,
  }
}

const replaceListsFromEditorial = html => {
  const newHtml = html.replace(/<ul>((?!<\/ul>).|\s)*<\/ul>/g, "{{ACCORDION}}")
  return newHtml
}

const getAccordionFromMarkup = html => {
  const accordionBlocks = html.match(/<ul>((?!<\/ul>).|\s)*<\/ul>/g)

  const accordionData = (accordionBlocks || []).map(ul => {
    let blocks = []
    const li = ul
      .replace("<ul>", "")
      .replace("</ul>", "")
      .replace("</li>", "")
      .split("<li>")
    li.forEach(elem => {
      const title = (
        elem
          .split("<strong>")
          .pop()
          .split("</strong>")[0] || ""
      )
        .replace("</li>", "")
        .trim()
      const content = (
        elem
          .split("</strong>")
          .pop()
          .split("</li>")[0] || ""
      ).trim()
      if (title && content)
        blocks.push({ title, content, simple: title === content })
    })
    return blocks
  })
  return accordionData
}

const createAmazonLink = (locale, asin) => {
  let amazonStore = "it"
  if (locale === "en") amazonStore = "co.uk"
  if (locale === "es") {
    const availableProducsEs = [
      "B086WGTGH2",
      "B086X577LN",
      "B086Z5SXX5",
      "B087CCBT5M",
      "B086VFMTNY",
      "B086XM1XZF",
      "B087V5NXBN",
      "B08CKHQD9Q",
      "B08VWFF4T7",
      "B08WC3ZTQH",
      "B08WJ4FWDD",
      "B08WH49B7K",
      "B08WPFGKN2",
      "B08WPWWC51",
      "B08WS3GPDT",
      "B08SR2VFD6",
      "B08TBY312R",
      "B08XQXTGNQ",
    ]
    if (availableProducsEs.includes(asin)) amazonStore = "es"
  }
  if (locale === "de") {
    const availableProducsDe = [
      "B087V5NXBN",
      "B086Z5SXX5",
      "B086WGTGH2",
      "B087CCBT5M",
      "B086X577LN",
      "B086XM1XZF",
      "B086VFMTNY",
      "B08VWFF4T7",
      "B08WC3ZTQH",
      "B08WJ4FWDD",
      "B08WH49B7K",
      "B08WPFGKN2",
      "B08WPWWC51",
      "B08WS3GPDT",
      "B08SR2VFD6",
      "B08TBY312R",
      "B08XQXTGNQ",
    ]
    if (availableProducsDe.includes(asin)) amazonStore = "de"
  }
  if (locale === "fr") {
    const availableProducsFr = [
      "B087CCBT5M",
      "B087V5NXBN",
      "B086Z5SXX5",
      "B086WGTGH2",
      "B086X577LN",
      "B086XM1XZF",
      "B086VFMTNY",
      "B08VWFF4T7",
      "B08WC3ZTQH",
      "B08WJ4FWDD",
      "B08WH49B7K",
      "B08WPFGKN2",
      "B08WPWWC51",
      "B08WS3GPDT",
      "B08SR2VFD6",
      "B08TBY312R",
      "B08XQXTGNQ",
    ]
    if (availableProducsFr.includes(asin)) amazonStore = "fr"
  }

  // oscuro alcuni asin
  if (asin === "B08769JQWW" && ["es", "de", "fr"].includes(locale)) {
    return undefined
  }
  return `https://amazon.${amazonStore}/dp/${asin}`
}

const stripHtml = html => {
  if (typeof document !== `undefined`) {
    const tmp = document.createElement("div")
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ""
  }

  return ""
}

const getImageUrl = image => {
  const fixed = image.localFile.childImageSharp.fixed
  const fluid = image.localFile.childImageSharp.fluid
  if (fluid && fluid.src) {
    return fluid.src
  }
  if (fixed && fixed.src) {
    return fixed.src
  }

  return ""
}

const getAmazonPrice = async asin => {
  try {
    const url = `https://us-central1-farmamed-website.cloudfunctions.net/api/amazon/${asin}`
    const result = await fetch(url)
    const data = await result.json()
    const amazonData = JSON.parse(data.content)
    if (
      amazonData &&
      amazonData.Offers &&
      amazonData.Offers.Listings &&
      amazonData.Offers.Listings.length > 0
    ) {
      return amazonData.Offers.Listings[0].Price.DisplayAmount
    }
  } catch (err) {
    console.log(err)
    return ""
  }
}

const createTicket = async payload => {
  try {
    const url = `/api/zendesk/new`

    const res = await fetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
    if (res.ok) {
      return true
    } else throw res.status
  } catch (err) {
    console.log("Error sending message: ", err)
    return false
  }
}

const goToUrl = url => {
  if (typeof window !== "undefined") {
    window.open(url)
  }
}

const getGalleryFromMarkup = html => {
  if (!html) return []
  const gallery = html.match(/\[galleria=(.)*]/g)
  if (!gallery) return []
  const images = gallery[0].replace("[galleria=", "").replace("]", "")
  return images.split(",")
}

export {
  localize,
  createMarkup,
  slugify,
  getAccordionFromMarkup,
  replaceListsFromEditorial,
  createAmazonLink,
  stripHtml,
  getImageUrl,
  getAmazonPrice,
  goToUrl,
  createTicket,
  getGalleryFromMarkup,
}
